import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { checkUserLogin } from "../../../helpers/functions";
import Dropdown from "../images/drop.png";
import NavbarCreatePetiton from "./NavbarCreatePetition";
import NavbarVoiceButton from "./NavbarVoiceButton";

const MenuModal = ({
  setIsMenuOpen,
  setisVerifyAccount,
  setIsShowModal,
  isLoggedIn,
  isVerified,
  isMenuOpen,
  isMobLangOpen,
  handleChangeLanguage,
  setIsMobLangOpen,
}) => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();

  return (
    <>
      {isMenuOpen && (
        <div className={`navbar__mobile-menu ${isMenuOpen ? 'navbar__mobile-menu--open' : ''}`}>
          <div className="navbar__mobile-header">
            <h3 className="navbar__mobile-title">Меню</h3>
          </div>
          
          <nav className="navbar__mobile-nav">
            <ul className="navbar__mobile-list">
              <li
                className="navbar__mobile-item"
                onClick={() => {
                  navigate("/");
                  setIsMenuOpen(false);
                }}
              >
                <span className="navbar__mobile-link">{t("navbar.main")}</span>
              </li>
              <li
                className="navbar__mobile-item"
                onClick={() => {
                  navigate("/petitions");
                  setIsMenuOpen(false);
                }}
              >
                <span className="navbar__mobile-link">{t("navbar.petitions")}</span>
              </li>
              <li
                className="navbar__mobile-item"
                onClick={() => {
                  navigate("/analytics");
                  setIsMenuOpen(false);
                }}
              >
                <span className="navbar__mobile-link">{t("navbar.analytics")}</span>
              </li>
              <li
                className="navbar__mobile-item"
                onClick={() => {
                  navigate("/about");
                  setIsMenuOpen(false);
                }}
              >
                <span className="navbar__mobile-link">{t("navbar.about")}</span>
              </li>
              <li
                className="navbar__mobile-item"
                onClick={() => {
                  if (isLoggedIn && isVerified) {
                    navigate("/create-petition");
                    setIsMenuOpen(false);
                  } else if (isLoggedIn && !isVerified) {
                    setisVerifyAccount(true);
                    setIsMenuOpen(false);
                  } else {
                    setIsShowModal(true);
                    setIsMenuOpen(false);
                  }
                }}
              >
                <span className="navbar__mobile-link">{t("navbar.submit")}</span>
              </li>
              {checkUserLogin() ? (
                <li
                  className="navbar__mobile-item"
                  onClick={() => {
                    navigate("/profile");
                    setIsMenuOpen(false);
                  }}
                >
                  <span className="navbar__mobile-link">{t("navbar.profile")}</span>
                </li>
              ) : (
                <li
                  className="navbar__mobile-item"
                  onClick={() => {
                    navigate("/login");
                    setIsMenuOpen(false);
                  }}
                >
                  <span className="navbar__mobile-link">{t("navbar.signIn")}</span>
                </li>
              )}
            </ul>
          </nav>

          <div className="navbar__mobile-actions">
            <div className="navbar__mobile-buttons">
              <NavbarVoiceButton setIsMenuOpen={setIsMenuOpen} />
              <NavbarCreatePetiton
                isLoggedIn={isLoggedIn}
                isVerified={isVerified}
                setisVerifyAccount={setisVerifyAccount}
                setIsShowModal={setIsShowModal}
              />
              <button
                className="navbar__mobile-login"
                onClick={() => {
                  navigate(isLoggedIn ? "/profile" : "/login");
                  setIsMenuOpen(false);
                }}
              >
                {isLoggedIn ? t("navbar.profile") : t("navbar.signIn")}
              </button>
            </div>
          </div>

          <div className="navbar__mobile-lang">
            <div 
              className="navbar__mobile-lang-header"
              onClick={() => setIsMobLangOpen(!isMobLangOpen)}
            >
              <span>{t("navbar.changeLang")}</span>
              <img src={Dropdown} alt="dropdown" />
            </div>
            {isMobLangOpen && (
              <div className="navbar__mobile-lang-select">
                <div
                  className="navbar__mobile-lang-item"
                  onClick={() => handleChangeLanguage("ru")}
                >
                  🇷🇺 Русский
                </div>
                <div
                  className="navbar__mobile-lang-item"
                  onClick={() => handleChangeLanguage("ky")}
                >
                  🇰🇬 Кыргызча
                </div>
                <div
                  className="navbar__mobile-lang-item"
                  onClick={() => handleChangeLanguage("en")}
                >
                  🇺🇸 English
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default MenuModal;
